const loadedCSS = new Set();

export function loadModalCSS(cssPath, insertAfterSelector = null) {
  if (loadedCSS.has(cssPath)) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssPath;

    link.onload = () => {
      loadedCSS.add(cssPath);
      resolve();
    };

    link.onerror = reject;

    // Specific insertion points for proper cascade order
    if (insertAfterSelector) {
      const referenceElement = document.querySelector(insertAfterSelector);
      if (referenceElement && referenceElement.nextSibling) {
        document.head.insertBefore(link, referenceElement.nextSibling);
        return;
      }
    }

    const firstCSSLink = document.querySelector('link[rel="stylesheet"]');
    if (firstCSSLink) {
      document.head.insertBefore(link, firstCSSLink);
    } else {
      document.head.appendChild(link);
    }
  });
}

// Specific modal CSS loaders with proper cascade insertion
export const loadSettingsModalCSS = () => loadModalCSS('/css/create.css'); // Insert before first CSS link
export const loadHistoryModalCSS = () => loadModalCSS('/css/modals/history.css', 'link[href*="/css/modals.css"]');
export const loadInventoryModalCSS = () => loadModalCSS('/css/inventory-drag-drop.css');
export const loadShopModalCSS = () => Promise.resolve(); // Legacy shop removed
